import { render, staticRenderFns } from "./OTPInput.vue?vue&type=template&id=6d934d7f&scoped=true"
import script from "./OTPInput.vue?vue&type=script&lang=js"
export * from "./OTPInput.vue?vue&type=script&lang=js"
import style0 from "./OTPInput.vue?vue&type=style&index=0&id=6d934d7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d934d7f",
  null
  
)

export default component.exports